<div class="d-flex flex-column flex-root " id="kt_login_wrapper">
    <!--begin::Login-->
    <div class="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-column-fluid bg-white" id="kt_login">

        <div class="parent login-content flex-row-fluid d-flex flex-column justify-content-center position-relative overflow-hidden  mx-auto    " >

            <div class="d-flex justify-content-lg-end justify-content-end align-items-end w-100 p-7" >
                <div class="flex-grow-2">
                    <img src="./assets/media/project-logos/Logo.png" class="max-h-90px " style="margin-left: 20px;max-height: 60px !important;" alt=""/>
                </div>
                <div class="align-self-center d-flex">

                    <i class="fas fa-user-circle cursor-pointer align-self-center" style="color: darkgray;font-size: 3rem;"  [matMenuTriggerFor]="menu" ></i>

                    <a [routerLink]="" (click)="endSession()" class=" highlight -primary ml-10 font-weight-bolder font-size-h5">Logout</a>
                </div>
            </div>




            <!-- <mat-menu #menu="matMenu" style="padding: 20px !important;border-radius: 20px">
                <a mat-menu-item routerLink="/" class=" font-weight-bolder font-size-h5 ">Dashboard</a>
                <a mat-menu-item href="#" class=" font-weight-bolder font-size-h5">Invite</a>
                <a  mat-menu-item href="#" class=" font-weight-bolder font-size-h5">Account</a>
            </mat-menu> -->
            <mat-menu #menu="matMenu" style="padding: 20px !important;border-radius: 20px">
                <a mat-menu-item routerLink="/" class=" font-weight-bolder font-size-h5 ">My Will</a>
                <a  mat-menu-item routerLink="/finish" routerLinkActive="active" class=" font-weight-bolder font-size-h5">My Plan</a>
                <a mat-menu-item routerLink="/download" routerLinkActive="active"class=" font-weight-bolder font-size-h5">Invite</a>
                <a mat-menu-item routerLink="/review" routerLinkActive="active"class=" font-weight-bolder font-size-h5">Review  Will</a>
                <a  [routerLink]="" (click)="endSession()"  mat-menu-item class=" font-weight-bolder font-size-h5 sm-remove-icon">Logout</a>
            </mat-menu>








            <!--end::Content-->
        </div>
        <!--end::Login-->
    </div>


    <div style="background: #F2FFF4">
        <div class="pb-13 pt-lg-0 pt-5">
            <p class="font-weight-bolder text-dark text-align-center font-heading mt-15" style="font-size: 2.4rem !important;">
                Thank you</p>

            <p class="text-align-center font-heading mt-5" style="font-size: 1.6rem !important; color: #8F8F8F">
                Create an account and come back any time </p>

            <p class="text-align-center " style="font-size: 1.6rem !important; color: #8F8F8F">
                to complete or update your Will. </p>
        </div>

        <div class="d-flex align-content-center justify-content-center">
            <img style="width: 100%;" src="assets/media/bg/group7636.png" alt="">
        </div>



        <div class="d-flex align-content-center justify-content-center" style="margin-top: 60px">

            <!-- <a [routerLink]="" class=" highlight -primary ml-10 font-weight-bolder font-size-h5 " style="padding-left: 30px;padding-right: 30px; margin-bottom: 60px">Invite Others</a> -->

        </div>



    </div>









    <!--<i class="fa fa-check-circle" aria-hidden="true"></i>-->
